import axios from "../../request";

const GET_TOP_ARTICLES = 'article/gettoparticles';
const GET_CATEGORY_ARTICLES = 'article/getcategoryarticles';
const GET_ARTICLE_FOR_DETAIL = 'article/getarticlefordetail';


export const getTopArticles = (params) => axios.post(GET_TOP_ARTICLES, params);
export const getCategoryArticles = (params) => axios.post(GET_CATEGORY_ARTICLES, params);
export const getArticleForDetail = (params) => axios.post(GET_ARTICLE_FOR_DETAIL, params);